import { render } from "./ServiceItsCardGalleryComp.vue?vue&type=template&id=35aa9f7b&scoped=true"
import script from "./ServiceItsCardGalleryComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsCardGalleryComp.vue?vue&type=script&lang=js"

import "./ServiceItsCardGalleryComp.vue?vue&type=style&index=0&id=35aa9f7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aa9f7b"]])

export default __exports__